<script setup lang="ts">
import { computed } from "vue";
import { DialogContent, DialogOverlay, DialogPortal } from "reka-ui";

const props = withDefaults(defineProps<{ size?: "md" | "lg" }>(), {
  size: "md",
});

const sizeClass = computed(() => {
  return props.size === "md" ? "w-md" : "w-xl";
});
</script>

<template>
  <DialogPortal>
    <DialogOverlay
      class="fixed inset-0 bg-background-overlay/40 z-40 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:fade-in"
    />
    <DialogContent
      :class="[
        'fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-background-primary rounded-xl border border-border-primary shadow-card flex z-40 max-h-[calc(100dvh-2.5rem)] max-w-[calc(100vw-1.25rem)]',
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:fade-in data-[state=open]:zoom-in-95',
        sizeClass,
      ]"
    >
      <slot />
    </DialogContent>
  </DialogPortal>
</template>
D
